<template>
  <div id="itemlist">
    <!-- 標題區域 -->
    <div 
      v-if="show=='1'"
      class="section-header"
      :class="winsize.width>=720? 'text-left':'text-center'"
    >
      <div class="header-content">
        <div class="title-wrapper">
          <div class="title-icon">
            <a-icon type="fire" />
          </div>
          <h2 class="section-title">推薦活動</h2>
          <div class="title-decoration"></div>
        </div>
        <div class="header-subtitle">為您精選最熱門的活動內容</div>
      </div>
    </div>

    <!-- 活動卡片區域 -->
    <transition-group name="card" tag="div">         
      <a-row v-if="item.length>0" type="flex" :justify="winsize.width>=720? 'start':'center'" :key="`row-${rowId}`">
        <a-col v-for="data in item" :key="data.id">
          <div class="modern-card-wrapper">
            <div class="modern-card" @click="golinks(data.id)">
              <!-- 圖片區域 -->
              <div class="card-image-wrapper">
                <img 
                  :src="data.url !== '' ? data.url : mainImg('event_1080x540.png')"
                  :alt="data.actitle"
                  class="card-image"
                >
                <div class="image-overlay">
                  <div class="overlay-content">
                    <a-icon type="eye" class="view-icon" />
                    <span>查看詳情</span>
                  </div>
                </div>
                <!-- 活動類別標籤 -->
                <div class="category-badge">
                  <a-avatar :size="20" :src="catImg(geturl(data.theme))" />
                </div>
              </div>

              <!-- 卡片內容 -->
              <div class="card-content">
                <!-- 標題 -->
                <div class="card-title-section">
                  <h3 class="card-title" :title="data.actitle">
                    {{ data.actitle.length > 13 ? data.actitle.substring(0, 13) + '...' : data.actitle }}
                  </h3>
                  <div class="title-underline"></div>
                </div>

                <!-- 活動資訊 -->
                <div class="card-info">
                  <div class="info-item">
                    <a-icon type="environment" class="info-icon location-icon" />
                    <span class="info-text">{{ data.address.substring(0, 8) }}...</span>
                  </div>
                  
                  <div class="info-item">
                    <a-icon type="clock-circle" class="info-icon time-icon" />
                    <span class="info-text">{{ fdateformat(data) }}</span>
                  </div>
                </div>

                <!-- 分隔線 -->
                <div class="card-divider"></div>

                <!-- 操作按鈕 -->
                <div class="card-action">
                  <div class="action-button">
                    <span>了解詳情</span>
                    <a-icon type="arrow-right" class="action-icon" />
                  </div>
                </div>
              </div>

              <!-- 懸停效果邊框 -->
              <div class="hover-border"></div>
            </div>
          </div>
          <hr v-if="winsize.width>=720" class="hr-dotted" style="margin-top: 1.5rem;">
        </a-col>                  
      </a-row>
    </transition-group>

    <!-- 空狀態 -->
    <div v-if="item !== undefined" style="margin:2rem;"> 
      <div v-if="item.length === 0" class="empty-state">
        <div class="empty-content">
          <a-icon type="inbox" class="empty-icon" />
          <h3 class="empty-title">暫無活動資料</h3>
          <p class="empty-description">目前沒有符合條件的活動，請稍後再來查看</p>
        </div>
      </div>         
    </div>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import MY_JSON from '../assets/json/optiondata.json'
import router from '../router'

export default {
  name: 'Actitemlist',
  props: {
    msg: String,
    item: Array,
    winsize: Object,
    kinds: String,
    show: String,
  },
  data() {
    return {
      myJson: MY_JSON,
      rowId: 1,
      window: {
        width: 0,
        height: 0
      }   
    }
  }, 
  methods: {
    fdateformat(val) {
      if (val.stime == undefined) {
        return moment(val.sdate).format("YYYY-MM-DD HH:mm") + '~' + moment(val.edate).format("MM-DD HH:mm"); 
      } else {
        return moment(val.sdate + " " + val.stime).format("YYYY-MM-DD HH:mm") + '~' + moment(val.edate + " " + val.etime).format("MM-DD HH:mm"); 
      }
    },
    
    catImg(imgs) {
      return require(`../assets/img/${imgs}`);
    }, 
    
    mainImg(imgs) {
      return require(`../assets/${imgs}`);
    },     
    
    geturl(theme) {
      let url = this.myJson.find(rs => rs.value == theme).url
      return url
    }, 
    
    getxt(val) {
      return val.substring(1, 32)
    },  
    
    golinks(val) { 
      if (this.kinds == 'new') {
        const routeData = this.$router.resolve({ name: 'Actinfo', params: { id: val }});
        window.open(routeData.href, '_blank');
      } else {
        router.push({ name: 'Actinfo', params: { id: val }}) 
      }  
    } 
  },   
  
  created() {
  }, 
}
</script>

<style scoped>
/* 主容器 - 保持原始設定 */
#itemlist {
  margin: 0px auto;
  padding: 0px;
  padding-left: 0.1rem;
  max-width: 1024px;       
}

/* 標題區域美化但保持原始位置 */
.section-header {
  max-width: 1024px;
  margin-top: -0.3rem;
  margin-left: 0.5rem;                
  border: 0px solid #333232;
  border-radius: 50px;
  padding: 10px;
}

.header-content {
  position: relative;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.title-wrapper.text-center {
  justify-content: center;
}

.title-wrapper.text-left {
  justify-content: flex-start;
}

.title-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
}

.section-title {
  font-family: 'Microsoft JhengHei', '微軟正黑體', 'Microsoft YaHei', sans-serif; 
  font-size: 22px; 
  font-weight: bold;
  margin: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-decoration {
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

.header-subtitle {
  color: #7f8c8d;
  font-size: 14px;
  margin: 0;
}

/* 卡片包裝器 - 保持原始尺寸 */
.modern-card-wrapper {
  cursor: pointer;
  margin: 10px;
  width: 20rem; /* 👈 保持原始寬度 */
  max-width: 20rem; /* 👈 保持原始最大寬度 */
}

@media (max-width: 720px) {
  .modern-card-wrapper {
    max-width: 100%;
  }
}

/* 現代化卡片 - 保持原始高度結構 */
.modern-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.01),
    0 4px 16px rgba(0, 0, 0, 0.02),
    0 8px 32px rgba(0, 0, 0, 0.03);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  border: 1px solid #f0f0f0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modern-card:hover {
  transform: translateY(-6px);
  box-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.02),
    0 4px 16px rgba(0, 0, 0, 0.03),
    0 8px 32px rgba(0, 0, 0, 0.04),
    0 10px 42px rgba(0, 0, 0, 0.06);
}

/* 圖片區域 - 保持原始高度 */
.card-image-wrapper {
  position: relative;
  overflow: hidden;
  height: 150px; /* 👈 保持原始高度 150px */
}

.card-image {
  max-height: 150px; /* 👈 保持原始設定 */
  max-width: 320px;  /* 👈 保持原始設定 */
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.modern-card:hover .card-image {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.modern-card:hover .image-overlay {
  opacity: 1;
}

.overlay-content {
  color: white;
  text-align: center;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.view-icon {
  font-size: 20px;
}

.category-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  padding: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 卡片內容 - 保持原始設定 */
.card-content {
  padding: 1rem; /* 👈 保持原始 padding */
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 320px; /* 👈 保持原始設定 */
}

.card-title-section {
  margin-bottom: 12px;
}

.card-title {
  font-weight: bold;
  font-size: 18px;
  height: 35px; /* 👈 保持原始高度 */
  text-align: left;
  word-break: break-word;
  margin: 0 0 8px 0;
  color: #2c3e50;
  line-height: 1.2;
  display: flex;
  align-items: center;
}

.title-underline {
  width: 30px;
  height: 2px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

/* 活動資訊 */
.card-info {
  margin-bottom: 16px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 6px;
}

.info-icon {
  font-size: 14px;
  width: 16px;
}

.location-icon {
  color: #e74c3c;
}

.time-icon {
  color: #3498db;
}

.info-text {
  color: #5d6d7e;
  font-size: 13px;
  line-height: 1.3;
}

/* 分隔線 */
.card-divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #e0e6ed 50%, transparent 100%);
  margin: 12px 0;
}

/* 操作按鈕 - 保持原始高度 */
.card-action {
  margin-top: auto;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 20px; /* 👈 調整為接近原始按鈕高度 */
  height: 30px; /* 👈 保持原始高度 */
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.modern-card:hover .action-button {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.action-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.modern-card:hover .action-icon {
  transform: translateX(4px);
}

/* 懸停邊框效果 */
.hover-border {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid transparent;
  border-radius: 20px;
  background: linear-gradient(135deg, #667eea, #764ba2) border-box;
  mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.modern-card:hover .hover-border {
  opacity: 1;
}

/* 分隔線保持原樣 */
.hr-dotted {
  border: 0;
  height: 1px;
  background: transparent;
  position: relative;
}

.hr-dotted:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-image: radial-gradient(circle, #333 20%, transparent 20%);
  background-size: 10px 3px;
  background-repeat: repeat-x;
}

/* 空狀態 */
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px;
}

.empty-content {
  text-align: center;
  max-width: 400px;
}

.empty-icon {
  font-size: 48px;
  color: #bdc3c7;
  margin-bottom: 16px;
}

.empty-title {
  font-size: 20px;
  font-weight: 600;
  color: #34495e;
  margin: 0 0 8px 0;
}

.empty-description {
  color: #7f8c8d;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

/* 卡片動畫 */
.card-enter-active, .card-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.card-enter, .card-leave-to {
  opacity: 0;
}

/* 響應式設計 */
@media (max-width: 720px) {
  .card-content {
    max-width: 100%;
  }
  
  .card-image {
    max-width: 100%;
  }
  
  .title-wrapper {
    justify-content: center;
  }
}
</style>